import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
export function MoreTestimonials() {
  const testimonials = [{
    initials: 'CR',
    rating: 5,
    text: 'Entendí que no era un problema mío. Era que no tenía el sistema.',
    author: 'Carlos R., Mendoza',
    badge: 'Código Acelerado'
  }, {
    initials: 'DM',
    rating: 5,
    text: 'El módulo de lenguaje no verbal me abrió la cabeza.',
    author: 'Diego M., Buenos Aires'
  }, {
    initials: 'SC',
    rating: 5,
    text: 'Los casos reales son lo mejor. Ver exactamente qué hizo otro en mi situación.',
    author: 'Sebastián C., La Plata'
  }, {
    initials: 'FA',
    rating: 5,
    text: 'Dejé de esperar que las cosas pasaran solas. Ahora sé qué hacer.',
    author: 'Facundo A., Neuquén'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-primary" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-4 text-center" data-id="element-156">
          ❤️ MÁS HOMBRES QUE YA LO TIENEN
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-16" data-id="element-157" />

        <div className="grid md:grid-cols-2 gap-6" data-id="element-158">
          {testimonials.map((testimonial, i) => <TestimonialCard key={i} {...testimonial} data-id="element-159" />)}
        </div>
      </div>
    </section>;
}